import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';
import { Subject } from 'rxjs';
import { ModalAlertService } from './alert.service';
import { TokenService } from '../api/token.service';
import { AuthService } from '../api/auth/auth.service';
import { IReqlogout } from '@pacifico/interfaces/auth-api.interface';
import { ModalLateralService } from '@pacifico/components/modal-side/modal-lateral.service';
import { SessionStorageService } from './storage/storage.service';
import { LocalStorageService } from '@pacifico/services/local/storage/local-storage.service';

export interface LoaderState {
	show: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	loaderSubject = new Subject<LoaderState>();
	interValID;
	session: IReqlogout = { environment: 'M', sessionId: '' };
	private showAlert = true;
	private showLogoutAlert = true;

	constructor(
		private _serviceModalAlert: ModalAlertService,
		private _route: Router,
		private _tokenService: TokenService,
		private _authService: AuthService,
		private _modalSideService: ModalLateralService,
		private _sessionStorageService: SessionStorageService,
		private _localStorageService: LocalStorageService,
		private ngZone: NgZone
	) {
		this.lastAction(Date.now());
		void this.check();
		this.initInterval();
	}

	loaderState = this.loaderSubject.asObservable();

	show(): void {
		this.loaderSubject.next({ show: true });
	}

	hide(): void {
		this.loaderSubject.next({ show: false });
	}

	closeSessionModal(message: string, title?: string, type?: string): boolean {
		let show = false;
		this.session = {
			environment: 'M',
			sessionId: this._tokenService.getToken()
		};

		if (this._tokenService.isLoggedIn()) {
			this._serviceModalAlert.showWarning(message, title, false).afterClosed.subscribe((response) => {
				this._authService.logout(this.session).subscribe((response) => {
					this._tokenService.deleteToken();
					this._sessionStorageService.clear();
					this._localStorageService.removeItem('lastAction');
					void this._route.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
				});
				this._serviceModalAlert.dialogComponentRef.destroy();
				this._modalSideService.forceCloseOnError();
			});
			show = true;
		} else {
			void this._route.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
		}
		this.hide();
		return show;
	}

	showAlertOnError(message: string, title?: string): boolean {
		let show = false;
		if (this._tokenService.isLoggedIn()) {
			this._serviceModalAlert.showWarning(message, title, false).afterClosed.subscribe((res) => {
				this._serviceModalAlert.dialogComponentRef.destroy();
				this._modalSideService.forceCloseOnError();
			});
			show = true;
		} else {
			void this._route.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
		}
		this.hide();
		return show;
	}

	getLastAction(): string | null {
		return localStorage.getItem('lastAction');
	}

	lastAction(value: unknown): void {
		localStorage.setItem('lastAction', JSON.stringify(value));
	}

	initInterval(): void {
		this.ngZone.runOutsideAngular(() => {
			setInterval(() => {
				if (this._tokenService.isLoggedIn()) {
					void this.check();
				}
			}, 1000);
		});
	}

	clearParameters(): void {
		this.showAlert = true;
		this.showLogoutAlert = true;
	}

	reset(): void {
		this.lastAction(Date.now());
	}

	check(): Promise<boolean> | void {
		const now = Date.now();
		const timeLeft = parseInt(this.getLastAction()!) + 5 * 60 * 1000;
		const timeAlertLeft = parseInt(this.getLastAction()!) + 4 * 60 * 1000;
		const diff = timeLeft - now;
		const diffAlert = timeAlertLeft - now;
		const isTimeout = diff < 0;
		const isTimeAlert = diffAlert < 0;
		//this.isLoggedIn.subscribe(event => this.isLogin = event);
		this.ngZone.run(() => {
			if (this.showAlert && isTimeAlert && this._tokenService.isLoggedIn() && !isTimeout) {
				this.hide();
				this.showAlert = false;
				const message = '¿Desea continuar?';
				const title = 'Su sesión está por terminar';
				this._serviceModalAlert
					.showWarning(message, title, true, false, false, 'CONTINUAR', 'SALIR')
					.afterClosed.subscribe((response) => {
						if (response === 0) {
							this.showAlert = true;
							this.reset();
							this._authService.refresh().subscribe();
						} else {
							this.session = {
								environment: 'M',
								sessionId: this._tokenService.getToken()
							};
							this.showLogoutAlert = false;
							this._authService.logout(this.session).subscribe((response) => {
								this._tokenService.deleteToken();
								this._sessionStorageService.clear();
								this._localStorageService.removeItem('lastAction');
								void this._route.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
							});
							this._serviceModalAlert.dialogComponentRef.destroy();
							this._modalSideService.forceCloseOnError();
						}
					});
			}

			if (this.showLogoutAlert && isTimeout && this._tokenService.isLoggedIn()) {
				this._serviceModalAlert.dialogComponentRef.destroy();
				this.showLogoutAlert = false;
				this.closeSessionModal('Su sesión ha terminado');
			}
		});
	}
}
